import React from 'react';
import PropTypes from 'prop-types';
import DropdownIcon from '@tradera/blueprint/theme/icons2/dropdown.svg?jsx';
import { Profile } from 'components';
import { useTranslator } from 'tradera-lang';
import MessageIcon from '@tradera/blueprint/theme/icons2/message.svg?jsx';

const ProfileLink = ({
    facebookId,
    handleProfileClick,
    isLoggedIn,
    memberAlias,
    menuExpanded,
    systemMessageCount,
    threadsUnread,
    transparentHeader
}) => {
    const { t } = useTranslator();
    const logInText = t('siteHeader_logIn');
    const tooltip = isLoggedIn ? t('siteHeader_myTradera') : logInText;
    const text = isLoggedIn ? memberAlias : logInText;

    let badgeType = 'primary';
    if (systemMessageCount > 0) {
        badgeType = 'danger';
    }
    const multipleBadges = threadsUnread > 0 && systemMessageCount > 0;

    return (
        <button
            aria-label={tooltip}
            aria-haspopup="true"
            aria-expanded={menuExpanded ? 'true' : 'false'}
            className={`btn d-flex z-modal align-items-center mr-0 mr-md-2 mr-xl-0 ${
                !isLoggedIn ? 'px-3' : 'px-2 px-sm-3'
            } ${menuExpanded && 'active'} ${
                transparentHeader
                    ? 'btn-translucent-branded'
                    : 'btn-link-branded'
            }`}
            title={tooltip}
            id="profile-button"
            onClick={handleProfileClick}>
            <span className="row d-flex align-items-center align-items-center no-gutters">
                <Profile
                    isLoggedIn={isLoggedIn}
                    facebookId={facebookId}
                    menuExpanded={menuExpanded}
                />
                {(threadsUnread > 0 || systemMessageCount > 0) && (
                    <span
                        className={`d-flex slim-header__notification-user badge badge-pill badge-pill-sm badge-${badgeType} ${
                            facebookId ? 'user__facebook' : ''
                        } ${
                            multipleBadges
                                ? 'slim-header__notification-multiple'
                                : ''
                        }`}>
                        {threadsUnread > 0 && (
                            <span className="d-inline-flex align-items-center">
                                <MessageIcon className="icon icon-sm icon-white pr-1" />
                                {threadsUnread < 100 ? threadsUnread : '99+'}
                            </span>
                        )}
                        {systemMessageCount > 0 && (
                            <span
                                className={`${
                                    threadsUnread > 0
                                        ? 'border-left border-white ml-2 pl-2'
                                        : ''
                                }`}>
                                {systemMessageCount}
                            </span>
                        )}
                    </span>
                )}
                <span className="slim-header__link-text slim-header__link-text--user col-auto pl-2 d-none d-lg-inline">
                    {text}
                </span>
                {isLoggedIn && (
                    <span className="pl-1 col-auto d-inline" aria-hidden="true">
                        <DropdownIcon className="icon icon-xs align-baseline" />
                    </span>
                )}
            </span>
        </button>
    );
};

ProfileLink.propTypes = {
    facebookId: PropTypes.string,
    handleProfileClick: PropTypes.func,
    isLoggedIn: PropTypes.bool,
    menuExpanded: PropTypes.bool,
    memberAlias: PropTypes.string,
    systemMessageCount: PropTypes.number,
    threadsUnread: PropTypes.number
};

export default ProfileLink;
